import { styles, variants, DialogTheme } from '../DialogStyles.css';
import { baseTheme } from './DialogBaseTheme.css';
import { multiVariantStyles } from './DialogVariants.css';

/*******************
 * Component Theme
 *******************/

const DialogStableTheme: DialogTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { DialogStableTheme };
